/**
 * @description renders the default body container wrapper, which creates a vertically stacked layout with the appropriate top and horizontal padding
 */

import Stack from '@mui/material/Stack';
import styled from '@mui/system/styled';

const BodyContainer = styled(Stack)({
  alignItems: 'stretch',
  flexWrap: 'nowrap',
  overflow: 'auto',
  padding: '1.5rem',
  width: '100%'
});

BodyContainer.defaultProps = {
  spacing: 2
};

export default BodyContainer;
